import '@patsnap-ui/icon/assets/solid/PatentReverse.svg'
import { drugDevStatusIndexFieldDescLangMap } from '@patsnap/synapse_common_config'
import { useLocale } from '@pharmsnap/shared/src/composition'
import { defineComponent, PropType } from '@vue/composition-api'
import { GIcon } from '../../ui/GIcon/GIcon'
import { GTooltip } from '../../ui/GTooltip/GTooltip'
export const BDrugPatentMiningTag = defineComponent({
  name: 'BDrugPatentMiningTag',
  props: {
    size: {
      type: String as PropType<'small' | 'medium'>,
      default: 'medium',
    },
  },
  setup() {
    const { tsText } = useLocale()
    return { tsText }
  },
  render() {
    return (
      <GTooltip
        theme="light"
        content={this.tsText({
          cn: drugDevStatusIndexFieldDescLangMap.PATENT_MINING?.cn || '',
          en: drugDevStatusIndexFieldDescLangMap.PATENT_MINING?.en || '',
          jp: drugDevStatusIndexFieldDescLangMap.PATENT_MINING?.jp || '',
        })}
      >
        <span
          class={[
            'inline-flex items-center bg-orange-light text-orange-dark rounded',
            this.size === 'small' ? 'text-xs pr-[2px] h-5 leading-[20px]' : 'text-sm pl-1 pr-2',
          ]}
        >
          <GIcon class="text-orange-dark" svgName="SolidPatentReverse" size={this.size === 'small' ? 20 : 24}></GIcon>
          <span>{this.tsText({ cn: '专利挖掘', en: 'patent mining', jp: '特許マイニング' })}</span>
        </span>
      </GTooltip>
    )
  },
})
